import { List, Map } from 'immutable';
import { regEventDb, registerHandler } from 'nike-re-framejs';

import {
    createClocksMapForScoreboard,
    pushEvent2ClocksMap,
    registerClocksHandler,
    start as startEventsClocks,
    stop as stopEventsClocks
} from '@/events/services/clocks';
import { createEventsMapForScoreboard, pushEvent2Map } from '@/events/services/events';
import { defaultMiddlewares } from '@/common/util';
import { scoreboardResetPaths } from './services/ticketDetail';

let clocksTimer;
registerClocksHandler('scoreboards.tick', ['scoreboard', 'clock']);

registerHandler('scoreboards.storeEvents', defaultMiddlewares, (db, [eventsArray]) =>
    db
        .mergeIn(['scoreboard', 'events'], createEventsMapForScoreboard(eventsArray))
        .mergeIn(['scoreboard', 'clock'], createClocksMapForScoreboard(eventsArray))
        .updateIn(['scoreboard', 'events'], events => events && events.map(value => (value ? value : null)))
);

registerHandler('scoreboards.applyMessage', defaultMiddlewares, (db, [data]) =>
    db
        .updateIn(['scoreboard', 'events'], Map(), actualMap => pushEvent2Map(actualMap, data, null, null))
        .updateIn(['scoreboard', 'clock'], Map(), actualMap => pushEvent2ClocksMap(actualMap, data, null, null))
);

regEventDb('scoreboard/start', defaultMiddlewares, db => {
    clocksTimer = startEventsClocks('scoreboards.tick');
    return db;
});

regEventDb('scoreboard/stop', defaultMiddlewares, db => {
    stopEventsClocks(clocksTimer);
    scoreboardResetPaths(List());
    return db
        .removeIn(['scoreboard', 'tickets'])
        .removeIn(['scoreboard', 'events'])
        .removeIn(['scoreboard', 'clock']);
});

regEventDb('scoreboard/clear', defaultMiddlewares, db => {
    scoreboardResetPaths(List());
    return db.removeIn(['scoreboard', 'tickets']).removeIn(['scoreboard', 'events']);
});
